import { animate, style, transition, trigger } from '@angular/animations';
import { Component, Inject, Input, TemplateRef, ViewEncapsulation } from '@angular/core';
import { MuiAnimationTiming } from '../utility';
import { Observable } from 'rxjs';
import { MuiBreadcrumbEntry } from './mui-breadcrumb-entry';
import { MuiBreadcrumbsService } from './mui-breadcrumbs.service';
import { MuiI18nProvider } from '../i18n';
import { MUI_APP_CONFIG, MuiModuleConfig } from '../config';

const outStyle = style({ opacity: 0, transform: 'translateX(1rem)' });
const inStyle = style({ opacity: 1, transform: 'none' });
const animations = [
  trigger('breadcrumbsList', [
    transition(':enter', [])
  ]),
  trigger('breadcrumb', [
    transition(':enter', [
      outStyle,
      animate(MuiAnimationTiming.EASE_OUT_SHORT, inStyle)
    ]),
    transition(':leave', [
      animate(MuiAnimationTiming.EASE_IN_SHORT, outStyle)
    ])
  ])
];

@Component({
  selector: 'mui-breadcrumbs',
  templateUrl: './mui-breadcrumbs.component.html',
  styles: [
    `
      :host,
      mui-breadcrumbs {
        display: inline-block;
      }
    `
  ],
  encapsulation: ViewEncapsulation.None,
  animations
})
export class MuiBreadcrumbs {

  @Input()
  label?: string;

  @Input() labelTemplate?: TemplateRef<unknown>;

  readonly breadcrumbs$: Observable<MuiBreadcrumbEntry[]>;
  protected readonly translations$: Observable<{ label: string }>;

  constructor(
    @Inject(MUI_APP_CONFIG) readonly routingOptions: MuiModuleConfig,
    private bcs: MuiBreadcrumbsService,
    private _i18n: MuiI18nProvider
  ) {
    this.breadcrumbs$ = this.bcs.breadcrumbs$;
    this.translations$ = this._i18n.breadcrumbs();
  }

  trackByIndex(index: number): number {
    return index;
  }
}
